import { Picture, Row, Column } from "../../components";
import { UiNavImagesModel } from "../../models";

import { Card } from "./components";

export type UINavImagesProps = {
    readonly model: UiNavImagesModel;
};

const UiNavImages = ({ model }: UINavImagesProps) => {
    return (
        <Row align="center">
            {model.content.pages
                .filter(({ type }) => type === "route")
                .map(({ id, content: { path, linkTitle, linkImage } }) => {
                    return (
                        <Column key={id} sm={{ span: "6" }} md={{ span: "4" }}>
                            <Card
                                href={path}
                                theme={model.content.theme}
                                containerId={model.id}
                                containerType={model.type}
                                label={linkTitle}
                                labelEnglish={path}
                                imageAlt={linkImage?.title}
                            >
                                {linkImage && <Picture image={linkImage} />}
                                {linkTitle && <span>{linkTitle}</span>}
                            </Card>
                        </Column>
                    );
                })}
        </Row>
    );
};

export default UiNavImages;
